import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { mileageRatePresetRepository } from '../data-access/repositories/MileageRatePresetRepository'

const base = ['mileage-rate-preset']

export const mileageRatePresetQueryConfig = {
  list: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => mileageRatePresetRepository.list(params),
  }),
  detail: (id: number) => ({
    queryKey: buildQueryKey([...base, id]),
    queryFn: () => mileageRatePresetRepository.getMileageRatePreset(id),
  }),
}
